import GameLayout from '~/pages/authentified/GameLayout';
import styled from 'styled-components';
//import logo from '@assets/images/logo/logo-trainpursuit.png'
import { Navigate, useNavigate } from 'react-router-dom';
//import { useState } from "react";
//import ChallengeDialog from "~/components/game/challenge-dialog";

import iconTrain from '@assets/images/icon/icon-train.png';
import { useLingui } from '@lingui/react';
import { WrapperItem } from '~/components/ui/wrapper-item';
import { classic } from '~/themes';
import { SSpan, SSpanText } from '~/components/styles/styles';
import ButtonExtended from '~/components/ui/button-extended';
import { GQL_UPDATE_USER } from '~/gql/users/users';
import { useMutation } from '@apollo/client';
// import { notification } from 'antd';
import { authClient } from '~/helpers/apollo';
import { Payload, useAuth } from '~/helpers/store/auth';
import { parseJwt } from '~/utils/jwt';

function FirstConnection() {
  const navigate = useNavigate();
  const { i18n } = useLingui();
  const { setPayload, payload } = useAuth();

  const [updateUser] = useMutation(GQL_UPDATE_USER, {
    client: authClient,
    onCompleted: (data) => {
      if (data.updateUser.tokens) {
        const dataJwt = parseJwt(data.updateUser.tokens.access_token);
        if (!dataJwt) {
          // notification.error({
          //   message: i18n._('common.login'),
          //   description: i18n._('impossible.read.token'),
          //   placement: 'bottomLeft',
          // });
          return;
        }
        const payload: Payload = {
          access_token: data.updateUser.tokens.access_token,
          refresh_token: data.updateUser.tokens.refresh_token,
          ...dataJwt,
        };
        setPayload(payload);
      }

      // notification.success({
      //   message: i18n._('update.user'),
      //   description: i18n._('good.update.user'),
      //   placement: 'bottomLeft',
      // });
    },
    onError: () => {
      // notification.error({
      //   message: i18n._('update.user'),
      //   description: i18n._('bad.update.user'),
      //   placement: 'bottomLeft',
      // });
    },
  });

  const handleChangeChallengeable = async (value: boolean) => {
    await updateUser({
      variables: {
        updateUserInput: {
          isChallengeable: value,
        },
      },
    });
    navigate('/home');
  };

  if (payload?.isChallengeable !== null) {
    return <Navigate replace to={'/home'} />;
  }

  return (
    <GameLayout backgroundSize="cover" withoutHeader withoutFooter>
      <WrapperItem iconSrc={iconTrain} widthLandscape="55%">
        <SSpan $textAlign="center" $color={classic.token?.colorText}>
          {i18n._('common.first.connection.title')}
        </SSpan>
        <SSpanText $textAlign="center">
          {' '}
          {i18n._('common.first.connection.text')}
        </SSpanText>
        <SBtnDiv>
          <SBtnItem>
            <ButtonExtended
              onClick={() => handleChangeChallengeable(true)}
              color="primary"
              text={i18n._('common.first.connection.challengeable.action')}
              secondaryText={i18n._(
                'common.first.connection.challengeable.text'
              )}
            />
          </SBtnItem>
          <SBtnItem>
            <ButtonExtended
              onClick={() => handleChangeChallengeable(false)}
              color="secondary"
              text={i18n._('common.first.connection.not.challengeable.action')}
              secondaryText={i18n._(
                'common.first.connection.not.challengeable.text'
              )}
            />
          </SBtnItem>
        </SBtnDiv>
      </WrapperItem>
    </GameLayout>
  );
}

export default FirstConnection;

const SBtnDiv = styled.div<{ $justifyContent?: string }>`
  align-items: center;
  display: flex;
  justify-content: ${({ $justifyContent }) =>
    $justifyContent ? $justifyContent : 'center'};
  margin-top: 10px;
  width: 100%;

  @media screen and (orientation: portrait) {
  }

  /* @media screen and (max-width: 450px) {
    flex: 0 0 50%;
    width: 90%;
    padding: 10px;
  }
  @media screen and (max-height: 800px) {
    flex: 0 0 50%;
    width: 90%;
    padding: 10px;
  } */
`;

const SBtnItem = styled.div`
  flex: 0 0 50%;
  padding: 10px;
`;
